import BreadcrumbSchema from '../../schema/BreadcrumbSchema';
import { InnerContainer } from '../common/inner-container';
import { AngledArrowDownIcon } from '../icons/icons';
import { RelLink } from '../rel-link';
import { BreadcrumbType, item } from './types';

export const Breadcrumb = (props: { breadcrumbList: BreadcrumbType; path: string }) => {
  const breadcrumbList = props.breadcrumbList;
  return (
    <div className="" data-testid="breadCrumb">
      <BreadcrumbSchema breadcrumbList={breadcrumbList} path={props.path} />
      <InnerContainer pyZero>
        <nav className="flex  w-full overflow-hidden" aria-label="Breadcrumb" data-testid="nav">
          <ol
            className="inline-flex items-center space-x-1 overflow-y-auto py-5 pr-4 md:space-x-3 md:py-4 md:pr-0 "
            data-testid="breadCrumbList"
          >
            <li
              className="ml-1 flex items-center text-black800  first:ml-0 hover:text-gray-900 md:ml-2"
              data-testid="breadCrumbItem"
            >
              <RelLink aria-label="Anasayfa" href="/" className="whitespace-nowrap  text-xs font-semibold md:text-sm ">
                Ana Sayfa
              </RelLink>
            </li>
            {breadcrumbList.map((item: item, index: number) => {
              return (
                <li
                  key={item.title + index}
                  className=" ml-1 flex items-center text-black800 last:pointer-events-none last:text-black700 hover:text-gray-900  md:ml-2 first:md:ml-0"
                  data-testid="breadCrumbItem"
                >
                  <AngledArrowDownIcon className="rotate-[-90deg] scale-[.7] md:scale-100" />
                  {item.url ? (
                    <RelLink
                      href={item.url}
                      className="whitespace-nowrap text-xs font-semibold   md:text-sm"
                      data-testid="breadCrumblink"
                    >
                      {item.title}
                    </RelLink>
                  ) : (
                    <span
                      className="whitespace-nowrap text-xs font-semibold   md:text-sm"
                      data-testid="breadCrumbTitle"
                    >
                      {item.title}
                    </span>
                  )}
                </li>
              );
            })}
          </ol>
        </nav>
      </InnerContainer>
    </div>
  );
};
